

export class DeviceModelStatusInput implements IDeviceModelStatusInput {
    /** The auto-generated id of the device model  master */
    deviceModelId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDeviceModelStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelId = _data["deviceModelId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceModelStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelId"] = this.deviceModelId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceModelStatusInput {
    /** The auto-generated id of the device model  master */
    deviceModelId: number;
    /** The updated status */
    status: number;
}

